import { ProfileCard } from '@components/Card'
import React from 'react'

export const ProfessionalCard = ({ person, ...rest }) => {
  const professional = person || { ...rest }
  const officeName = professional?.offices?.[0]?.title || professional?.office
  return (
    <ProfileCard
      person={{ ...professional, office: officeName }}
      displayName
      displayTitle
      displayAvatar
      defaultFontSize={16}
      float="left"
      height="auto"
      contactUs
    />
  )
}
